import breadcrumbs from './FAQ_breadcrumbs';
import questions from './FAQ_questions';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    questions,
  },
};
